"use client";

import {
  BrowserClient,
  Identify,
  ValidPropertyType,
} from "@amplitude/analytics-types";

interface IIdentify {
  new (): Identify;
}

declare global {
  interface Window {
    dataLayer?: {
      push?: (value: Record<string, unknown>) => void;
    };
    amplitude?: BrowserClient & { Identify: IIdentify };
  }
}

export function pushAnalyticsEvent({
  eventName,
  ...rest
}: { eventName: string } & Record<string, unknown>): void {
  pushEventToDataLayer({
    event: eventName,
    ...rest,
  });
  pushToAmplitude(eventName, rest);
}

export function pushEventToDataLayer(
  item: { event: string } & Record<string, unknown>
): void {
  pushVariablesToDataLayer(item);
}

export function pushVariablesToDataLayer(item: Record<string, unknown>) {
  if (
    typeof window?.dataLayer?.push === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    window.dataLayer.push(item);
  }
}

export function pushToAmplitude(
  eventName: string,
  eventProperties: Record<string, unknown>
): void {
  if (
    typeof window?.amplitude?.track === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    window.amplitude.track(eventName, eventProperties);
  }
}

export function identifyUser(
  userId: string,
  props?: Record<string, ValidPropertyType | undefined>
): void {
  if (typeof window?.amplitude?.setUserId !== "function") {
    return;
  }
  window.amplitude.setUserId(userId);

  if (props) {
    setUserProperties(props);
  }
}

export function pushExperimentToAmplitude(name: string, variant: string): void {
  if (
    typeof window?.amplitude?.track === "function" &&
    typeof window?.amplitude?.track === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    setUserProperties({ [name]: variant });
    window.amplitude.track(`Experiment Viewed`, { name, variant });
  }
}

function setUserProperties(
  properties: Record<string, ValidPropertyType | undefined>
) {
  if (
    typeof window?.amplitude?.identify === "function" &&
    typeof window?.amplitude?.Identify === "function" &&
    process.env.NODE_ENV !== "development"
  ) {
    const identifyEvent = new window.amplitude.Identify();

    for (const property in properties) {
      identifyEvent.set(property, properties[property] || "");
    }

    window.amplitude.identify(identifyEvent);
  }
}
